export const layoutLocators = {
  draggable: 'Layout-Draggable',
  serviceLoadingIndicator: 'Layout-ServiceLoadingIndicator',
};
